<template>
  <div class="container text-center pb-5 mt-5">
    <h1 class="fw-bold mb-3">{{ $t('OutOfInventory.Title') }}</h1>
    <p class="">{{ $t('OutOfInventory.Desc') }}</p>
    <p class="mt-5">
      <a href="https://glade.com/en-us" target="_blank" class="btn-link"
        >Shop Glade</a
      >
    </p>
  </div>
</template>

<script>
export default {
  name: 'OutOfInventory',
};
</script>
